import axios from "axios";
import authHeader from "./services/authHeader"

export default axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_URL/+"api/",
  headers: authHeader()
});